import {useParams} from "react-router-dom";

import {ICustomField} from "@evennt-tech/api-v2-core";
import {shallow} from "zustand/shallow";
import {useLocalisedLanguageCode} from "hooks/translation";
import {useCustomFields} from "store/custom-field/custom-field.store";
import {useEffect} from "react";

type UseShowCustomFieldsResult = [ICustomField[], boolean?];

type Args = {
  localised?: boolean;
};

export default ({localised = false}: Args = {}): UseShowCustomFieldsResult => {
  const {showId} = useParams<{showId?: string}>();
  const languageCode = useLocalisedLanguageCode(localised);

  const {
    fetch: fetchCustomFieldsInShow,
    autoCatch: autoCatchCustomFields,
  } = useCustomFields();

  const customFields = useCustomFields((state) =>
    state.getByShowId(showId as string)
  );

  const isLoading = useCustomFields((state) => state.isLoading, shallow);

  useEffect(() => {
    if (!showId) {
      return;
    }

    const load = async () => {
      await autoCatchCustomFields(showId);
      await fetchCustomFieldsInShow(showId, false, languageCode);
    };

    load();
  }, [showId, languageCode]);

  return [customFields, isLoading];
};
